import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CSSProperties } from 'react';

import { type StudentDayStats } from '../model';
import { DailyProgressGraph } from './DailyProgressGraph';
import { StudentProgressHeader } from './StudentProgressHeader';
import { WeeklyProgressGraph } from './WeeklyProgressGraph';
import { getTodaysDayName } from './utils';

const Container = styled(Stack)`
  gap: 50px;
`;

type Props = {
  subject: string;
  data: Record<string, StudentDayStats> | undefined;
  showHeader?: boolean;
  style?: CSSProperties;
  isUserLearnAndEarn?: boolean;
  goalSummary: {
    dailyCompletedLessons: number;
    weeklyCompletedLessons: number;
    dailyGoal: number;
    weeklyGoal: number;
    personalDailyGoal: number | null | undefined;
    personalWeeklyGoal: number | null | undefined;
  };
};

export const StudentProgressView = ({ data, goalSummary, showHeader = true, style }: Props) => {
  const dayName = getTodaysDayName();

  return (
    <Container style={style}>
      {showHeader && <StudentProgressHeader data={data} />}
      <DailyProgressGraph
        personalGoal={goalSummary.personalDailyGoal}
        currentDay={dayName}
        todaysGoal={goalSummary.dailyGoal}
        completedLessons={goalSummary.dailyCompletedLessons}
      />
      <WeeklyProgressGraph
        data={data}
        personalGoal={goalSummary.personalWeeklyGoal}
        completedLessons={goalSummary.weeklyCompletedLessons}
        weeklyGoal={goalSummary.weeklyGoal}
        weeklyPersonalGoal={goalSummary.personalWeeklyGoal}
      />
    </Container>
  );
};
